import { bov3_api } from '../..';
import { PropertyType } from '../../../common';

export const setupTwoStepKey = (data: PropertyType): Promise<PropertyType> => {
	const payload: PropertyType = {
		sid: data.sid || data.token,
		request: 'SetupTwoStepKey',
	};

	if (data.secret !== undefined) {
		payload.secret = data.secret;
	}

	if (data.two_step_code !== undefined) {
		payload.two_step_code = data.two_step_code;
	}

	return bov3_api.post(``, payload).then((res) => {
		if (res.data?.resultCode !== 0) {
			throw new Error(res.data?.errorMessage || 'Failed to setup two-step key');
		}
		return res.data;
	});
};
